<template>
  <v-dialog v-model="value" max-width="600" persistent>
    <v-form @submit.prevent="submit()" ref="form" :lazy-validation="true" :disabled="isLoading">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between align-center primary white--text py-2">{{ $t('payment.add_discount_reserve_money') }}</v-card-title>
        <v-card-text>
          <v-row class="mt-4">
            <v-col cols="12" class="py-1">
              <span>{{ $t('bill.bill_discount_list') }}</span>
              <template v-if="!isLoading && accountingProductDiscounts && accountingProductDiscounts.length">
                <v-autocomplete v-model="formData.accountingProduct" :items="accountingProductDiscounts"
                  :no-data-text="$t('bill.no_bill_discount_list')" item-text="name" item-value="objectId" flat
                  background-color="grey lighten-4" solo :label="$t('bill.bill_list')" :rules="[rules.required]"></v-autocomplete>
              </template>
              <div v-else class="pl-5">{{ $t('validate.no_bill_discount_list_please_add_bill_discount_list') }}</div>
            </v-col>
            <v-col cols="12" class="py-1">
              <span>{{ $t('payment.reservation_List') }}</span>
              <template v-if="!isLoading && filteredBookingAreaCustomerInvoices && filteredBookingAreaCustomerInvoices.length">
                <v-autocomplete v-model="formData.invoice" :items="filteredBookingAreaCustomerInvoices" item-text="documentId"
                  item-value="objectId" solo flat background-color="grey lighten-4" :rules="[rules.required]"
                  :label="$t('payment.reservation_List')">

                  <template v-slot:item="{ item }">
                    <div>
                      {{ $t('invoice.invoice_number_only') }} {{ item.documentId }}
                    </div>
                    <div class="pl-2">
                      {{ $t('booking.booking_amount') }} {{ item.totalValue | currencySuffixSign(item.currencyCode) }}
                    </div>
                  </template>
                </v-autocomplete>
              </template>
              <div v-else class="pl-5">{{ $t('booking.no_booking_bill_list') }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" elevation="0" type="submit"
            :disabled="isLoading || !formData.accountingProduct || !formData.invoice">{{ $t('payment.add_discount') }}</v-btn>
          <v-btn color="error" elevation="0" @click="dismiss()" :disabled="isLoading">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: { 
    value: Boolean, 
    contractData: Object,
    currencyCode: {
      type: String,
      default: function() {
        return this.$globalCurrencyCode
      }
    }
  },
  computed: {
    ...mapGetters({
      marketId: "markets/getMarketId",
      invoice: "invoice/getInvoice",
      area: "area/getCurrentArea",
      accountingProductDiscounts: "accountingProducts/getAccountingProductDiscounts",
      bookingAreaCustomerInvoices: "booking/getBookingAreaCustomerInvoices"
    }),
    filteredBookingAreaCustomerInvoices() {
      return this.bookingAreaCustomerInvoices.filter(d => d.currencyCode == this.currencyCode)
    }
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('validate.please_select'),
      },
      isLoading: false,
      formData: {
        accountingProduct: null,
        invoice: null,
      }
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.resetForm();
      }
    },
  },
  async created() {
    this.isLoading = true
    if (((this.area && this.area.objectId) || (this.invoice && this.invoice.contract && this.invoice.contract.areas)) && ((this.contractData && this.contractData.customer) || (this.invoice && this.invoice.contract && this.invoice.contract.customer))) {
      let customerId, areaIds
      if (this.invoice && this.invoice.contract) {
        customerId = this.invoice.contract.customer.objectId
        areaIds = this.invoice.contract.areas.map(a => a.objectId)
      } else {
        customerId = this.contractData && this.contractData.customer ? this.contractData.customer.id : ''
        areaIds = this.area ? [this.area.id ? this.area.id : this.area.objectId] : []
      }
      await this.getBookingByAreaCustomer({ areaIds, customerId })
    }
    this.isLoading = false
  },
  methods: {
    ...mapActions({
      getBookingByAreaCustomer: "booking/getBookingByAreaCustomer"
    }),
    dismiss() {
      this.$emit("input", false);
    },
    resetForm() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.formData = {
        accountingProduct: null,
        invoice: null
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        let postData = {
          accountingProduct: null,
          invoice: null
        }
        postData.accountingProduct = this.accountingProductDiscounts.find(d => d.objectId == this.formData.accountingProduct)
        postData.invoice = this.bookingAreaCustomerInvoices.find(d => d.objectId == this.formData.invoice)
        this.$emit("onSuccess", postData);
        this.dismiss()

      }
    },
  }
}
</script>